const SHARED_PAY_METHOD_LABELS = {
  agent_account: '现金账户',
  voucher_account: '裂变奖金账户',
  gold_account: '金账户',
  alipay_code: '缴费通-支付宝',
  wechat_code: '缴费通-微信',
  pos: '缴费通-POS',
  mixue_alipay_code: '支付宝',
  mixue_wechat_code: '微信',
  bank_pay: '对公转账',
  consulting_fee_pay: '咨询费抵扣',
  refund_consulting_fee_non_opened_campus: '未开业校区咨询费退费',
  refund_consulting_fee_opened_campus: '已开业校区咨询费退费',
  pine_nut_pay: '松子抵扣',
  online_student_tuition: '在线学员学费',
  squirrel_consulting_fee: '小松鼠咨询费',
  fees_unconverted_pine_nut: '运营未转化松子的课时费',
  squirrel_class_fee: '小松鼠课时费',
  operation_quality_education_fee: '运营素质教育费',
  transfer_pay: '拓展校区转介绍费用',
  introduction_learning_machine_transfer: '拓展学习机转介绍费用',
  expansion_counter_subsidy_fee: '拓展柜台补贴费用',
  regional_release_pay: '拓展释放兜底费用',
  agreement_pay: '拓展补充协议赠送费用',
  other_operating_expenses: '运营其他费用',
  other_expenses_expansion: '拓展其他费用',
  squirrel_other_expenses: '小松鼠其他费用',
  operating_card_payment: '运营办学卡款',
  release_money: '兜底释放款',
  base_school_repayment: '基地校返还款',
  increased_amount_of_pine_nuts: '松子增额金额',
  reward_amount: '奖励金额',
  cash_amount: '现金金额',
  cash_back_amount_card: '订阅卡返现金额',
  return_amount_other: '其他补贴返还金额',
  share_bonus: '分享奖金',
  regional_agent_cash_back: '区域代理返现',
  collection_on_delivery: '代收货款',
  region_service_charge: '区代服务费',
  activate_reward: '激活奖励',
  deposit_reward_purchase_voucher: '订金奖励-进货券',
  member_awards: '委员奖励',
  collection_on_delivery_reward: '代收货款-现金（非）',
  collection_on_delivery_cash: '代收货款-现金',
  recharge_underwriting_policy: '包销政策充值',
  agency_price_difference: '代理差价',
  collection_on_delivery_fission: '代收货款-裂变',
  venue_order_payment: '会场订货款',
  hardware_cost: '硬件费用',
  cash_amount_account_fee: '账号费现金金额',
  cash_payment: '支付现金',
  other: '其他',
};

export default {
  finance: {
    accountAssets: '账户资产看板',
    accountAssetsBoard: '账户资产看板',
    dataStatsCutoff: '此看板所有数据统计截止时间：',
    accountBalance: '账户余额',
    commonAccount: '通用账户',
    agentAccount: '代理商账户',
    companyAccount: '公司账户',
    voucherAccount: '裂变奖金账户',
    goldAccount: '金账户',
    cashAccount: '现金账户',
    withdrawalAccount: '提现账户',
    bankTransfer: '对公转账',
    hqCoBuildAccount: '总部共建账户',
    convertibleOptionAmount: '可兑换期权金额',
    promotionAmount: '推广费',
    cityAmount: '深扎城市费',
    deliveryVoucherAccount: '提货券账户',
    deliveryVoucherShort: '提货券',
    deliveryAccountBalance: '提货券账户余额',
    issuedDeliveryVoucher: '发放的提货券',
    verifiedDeliveryVoucher: '核销的提货券',
    dualOrderPendingReturnVoucher: '双重订单待返提货券',
    equipmentAssets: '设备资产',
    equipmentType: '设备类型',
    cashAmount: '现金金额',
    voucherAmount: '提货券金额',
    totalAmount: '合计',
    freightAmount: '运费',
    orderAssets: '订单资产',
    purchaseOrder: '采购订单',
    undeliveredPurchaseTotal: '未发货采购订单总金额',
    undeliveredPurchaseCash: '未发货采购订单现金金额',
    undeliveredPurchaseVoucher: '未发货采购订单裂变金额',
    creditOrderUndeliveredTotal: '赊货订单未发货已支付总金额',
    creditOrderUndeliveredCash: '赊货订单未发货已支付现金金额',
    creditOrderUndeliveredVoucher: '赊货订单未发货已支付裂变金额',
    deliveryOrder: '发货订单',
    shippedUnpaidTotal: '已发货未回款订单总金额',
    shippedUnpaidCash: '已发货未回款现金金额',
    shippedUnpaidVoucher: '已发货未回款裂变金额',
    creditOrderShippedUnpaidTotal: '赊货订单已发货未回款订单总金额',
    creditOrderShippedUnpaidCash: '赊货订单已发货未回款现金金额',
    creditOrderShippedUnpaidVoucher: '赊货订单已发货未回款裂变金额',
    noDetailPermission: '您的账号没有进入该详情页面的权限！',
    expenseRecord: '消费记录',
    rechargeRecord: '充值记录',
    recharge: '充值',
    withdraw: '提现',
    transfer: '转账',
    inventoryValue: '库存存货价值',
    includeVoucher: '含裂变',
    pay: '支付',
    remainingUnorderedAmount: '剩余未下单金额',
    detail: '详情',
    totalPaymentAmount: '提货款总额',
    paidPaymentAmount: '已付提货款金额',
    withdrawableAmount: '可提现金额',
    loanAmount: '货款类',
    notLoanAmount: '非货款类',
    nonPaymentRebateService: '非货款-返佣服务费',
    nonPaymentReferralCommission: '非货款-转介绍佣金',
    nonPaymentOther: '非货款-其他',
    loanAmountLabel: '货款类金额',
    notLoanAmountLabel: '非货款类金额',
    nonPaymentRebateServiceLabel: '非货款-返佣服务费余额',
    nonPaymentReferralCommissionLabel: '非货款-转介绍佣金余额',
    nonPaymentOtherLabel: '非货款-其他余额',
    inventoryValueTipA: '统计库存设备中，未软件激活的正价学习机商品对应采购订单采购单价合计',
    inventoryValueTipB: '亲子机、样机不统计',
    serialNo: '流水号',
    rechargeAmount: '充值金额',
    rechargeMethod: '充值方式',
    rechargeTime: '充值时间',
    operator: '操作人',
    remark: '备注',
    accountType: '账户类型',
    account: '账户',
    rechargeSerial: '充值流水',
    pleaseEnterRechargeSerial: '请输入充值流水',
    pleaseSelectAccountType: '请选择账户类型',
    pleaseSelectRechargeMethod: '请选择充值方式',
    withdrawalSerial: '提现单号',
    pleaseEnterWithdrawalSerial: '请输入提现单号',
    withdrawalTime: '提现时间',
    withdrawalAmount: '提现金额',
    paymentCategoryWithdrawAmount: '货款类提现金额',
    noPaymentCategoryWithdrawAmount: '非货款类提现金额',
    paymentCategoryTransferAmountTotal: '货款类转移金额合计',
    noPaymentCategoryTransferAmountTotal: '非货款转移金额合计',
    rechargeType: '充值类型',
    pleaseSelectRechargeType: '请选择充值类型',
    paymentCategoryType: '货款类',
    nonPaymentCategoryType: '非货款类',
    rechargeTypeAllAmount: '混合类',
    applyStatus: '申请状态',
    pleaseSelectApplyStatus: '请选择申请状态',
    withdrawStatusPendingSubmit: '待提交',
    withdrawStatusPendingReview: '待审核',
    withdrawStatusPendingPay: '待打款',
    transferAmount: '转移金额',
    transferTime: '转移时间',
    cashAccountTransferTime: '转移时间',
    transferAccountType: '转移账户类型',
    payeeName: '收款人姓名',
    depositBank: '开户银行',
    payeeReceivingBank: '收款银行',
    payeeAccount: '收款账号',
    paymentUser: '打款人',
    pleaseSelectProject: '请选择项目',
    pleaseEnterSettlementNo: '请输入结算单号',
    settlementAmount: '结算金额',
    receivedAmount: '实付金额',
    paymentTime: '打款时间',
    pleaseSelectExpenditureMethod: '请选择支出方式',
    queryListFail: '查询列表失败',
    orderNo: '采购单号',
    buyNum: '采购数量',
    orderAmount: '采购金额',
    payAmount: '支付金额',
    currency: '币种',
    payMethod: '支付方式',
    collectWaterPayMethod: {
      ...SHARED_PAY_METHOD_LABELS,
      bank_pay_confirm: '对公转账确认',
      withdrawal_account: '提现账户',
      cooperate_account: '总部共建账户',
      return_first_order: '首笔订货款-返还',
      subscription_fee_rebate: '订阅费返佣',
      commodity_added_service_fee: '商品增值服务费',
      squirrel_cup_award_amount: '松鼠杯奖励金额',
      rewards_persuaders_debt_repurchase: '债权回购劝说人奖励',
      focus_fund: '分众基金',
      renewal_payment_return: '续费货款-返还',
      delivery_account: '提货券账户',
      delivery_voucher: '提货券',
      collection_interest_margin: '货款利差分配',
      organ_customer_upgrade_difference: '机构客户升级差价',
      tmall_proxy_operation_pre_recharge: '天猫代运营预充值',
      cloud_wechat_code: '支付宝',
      cloud_alipay_code: '微信',
      channel_merchant_settlement: '渠道商结算',
      reward_options: '奖励期权',
      channel_options: '渠道期权',
      lecturer_options: '讲师期权',
      diversified_fund_options: '分众基金期权',
      other_options: '其他期权',
      delivery_voucher_cash: '提货券-现金',
      delivery_voucher_reward: '提货券-奖励',
      deduction_recharge: '扣款回充',
      delivery_voucher_gold: '提货券-金账户',
      angli_sub_card_profit_sharing: '昂立订阅卡分润',
      cloud_substitute_alipay_code: '松鼠云支付宝',
      cloud_substitute_wechat_code: '松鼠云微信',
      reimbursement: '客户参访报销',
      investment_meeting_prototype_policy: '招商会样机政策',
      beginner_account_return: '入门账号返还',
      channel_agent_first_reward: '渠道代-首笔款奖励',
      channel_agent_rebate_reward: '渠道代-返佣奖励',
      channel_agent_service_fee_reward: '渠道代-服务费奖励',
      market_promotion_fee_refund: '市场推广费返还',
      transfer_customer_payment_withdrawal: '转介绍客户货款提现',
      reimbursement_for_recycling_equipment: '回收设备补款',
      supplementary_express_delivery_fee: '补充快递费',
      first_payment_reward_for_partners: '合伙人首笔款奖励',
      partner_renewal_reward: '合伙人续费奖励',
      shaping_account_promote: '共建账户-推广费',
      transfer_gold_acct_to_options: '金账户转期权',
      transfer_cash_acct_to_options: '现金账户转期权',
      transfer_fission_gold_acct_to_options: '裂变金账户转期权',
      transfer_withdrawal_acct_to_options: '提现账户转期权',
      transfer_cobranded_mktg_fund_to_options: '共建账户市场推广费转期权',
      transfer_cobranded_city_fund_to_options: '共建账户深扎城市费转期权',
      transfer_voucher_to_options: '提货券转期权',
      transfer_cloud_warehouse_assets_to_options: '云仓资产转期权',
      transfer_offline_inventory_to_options: '线下库存转期权',
    },
    payTime: '支付时间',
    paymentFlowTime: '支付时间',
    pleaseEnterOrderNo: '请输入采购单号',
    purchaseExport: '采购单导出',
    deliveryInfoExport: '发货信息导出',
    deliveryInfoImport: '发货信息导入',
    allocateManufacturer: '分配生产厂商',
    generateDeliveryOrder: '生成发货单',
    splitDelivery: '拆分发货',
    deliveryOrderNo: '发货单号',
    createTime: '创建时间',
    operation: '操作',
    initialPayment: '初始付款',
    more: '更多',
    performanceSplit: '业绩分单',
    delete: '删除',
    discount: '优惠',
    drawInvoice: '开发票',
    printDeliveryOrder: '打印发货单',
    returnGoods: '退货',
    returnFreight: '退运费',
    manufacturer: '生产厂商',
    pleaseSelectManufacturer: '请选择厂商',
    cancel: '取消',
    confirm: '确定',
    deliveryOrderConfirm: '发货单确认',
    productName: '商品名称',
    waitSendNum: '待发数量',
    thisDeliveryNum: '本次发货数量',
    pleaseEnterDeliveryNum: '请输入发货数量',
    allocateManufacturerSuccess: '分配生产厂商成功',
    allocateManufacturerFail: '分配生产厂商失败',
    generateDeliverySuccess: '生成发货单成功！',
    generateDeliveryFail: '生成发货单失败！',
    splitDeliverySuccess: '发货单拆分成功！',
    splitDeliveryFail: '发货单拆分失败！',
    pleaseSelectOrder: '请选择订单',
    pleaseSelectDeliveryOrder: '请选择发货单',
    pleaseSelectPurchaseOrder: '请选择采购单',
    singleOrderSplitOnly: '仅支持单个订单拆分发货',
    orderNotSupportSplit: '当前订单不支持拆分',
    deliveryNumExceedWait: '本次发货数量不可大于待发数量',
    orderWithVoucherCannotCancel: '该订单已返提货券，不可进行取消',
    pleaseEnterPositiveInteger: '请输入正整数',
    exportDeliveryList: '发货单列表导出',
    goodsTransferRecord: '调货记录',
    export: '导出',
    snCode: 'SN码',
    pleaseEnterSnCode: '请输入SN码',
    transferOutAgent: '调出代理商',
    transferInAgent: '转入代理商',
    pleaseSelectAgent: '请选择代理商',
    goodsTransferTime: '调货时间',
    productType: '商品类型',
    currentAvailableSampleIndex: '当前可用样机指标',
    sampleIndexQueryExportFileName: '样机指标查询导出',
    sampleIndexRuleInterpretation: '关于样机指标的规则及解读',
    newGbChargerOwnCnt: '采购学习机获得指标数',
    newGbChargerUseCnt: '已使用指标数',
    newGbChargerAvailableCnt: '当前可用指标数',
    newGbChargerIndexQueryExportFileName: '新标准充电器指标查询导出',
    expenseCalendarPayTime: '支付时间',
    invoicePdf: '发票.pdf',
    equityInfo: '权益信息',
    verificationInfo: '核销信息',
    pleaseSelectProductType: '请选择商品类型',
    deviceSnCode: '设备SN码',
    transferOutAgentId: '调出代理商ID',
    transferOutAgentName: '调出代理商名称',
    transferOutOrderNo: '调出订单编号',
    transferInAgentId: '转入代理商ID',
    transferInAgentName: '转入代理商名称',
    transferInOrderNo: '调入订单编号',
    transferPerson: '调货人',
    hqTransferRecordExport: '总部调货记录导出',
    applicationRecord: '体验账号申请记录',
    applicationDate: '申请日期',
    applicationPhone: '申请手机号',
    pleaseEnterPhone: '请输入手机号',
    applicationTime: '申请时间',
    experienceAccount: '体验账号',
    experienceAccountPassword: '体验账号密码',
    accountValidDate: '账号有效日期',
    queryFail: '查询失败',
    operationSuccess: '操作成功',
    operationFail: '操作失败',
    submitSuccess: '提交成功',
    submitFail: '提交失败',
    cancelSuccess: '取消成功',
    cancelFail: '取消失败',
    confirmSuccess: '确认成功',
    confirmFail: '确认失败',
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    modifySuccess: '修改成功',
    deleteSuccess: '删除成功！',
    withdrawSuccess: '提现成功',
    pleaseEnterReimburseAmount: '请输入报销金额',
    pleaseSelectExpressCompany: '请选择快递公司',
    pleaseEnterExpressNo: '请输入快递单号',
    pleaseEnterExpressPhone: '请输入快递手机号',
    onlyUploadPdfPngJpg: '只限上传pdf、png、jpg、jpeg类型文件',
    maxUpload20M: '最大可上传20M的文件',
    onlyUploadPngJpgPdf: '只限上传png、jpg、jpeg、pdf类型文件',
    maxUpload5M: '最大可上传5M的文件',
    pleaseEnter11DigitPhone: '请输入11位的快递手机号',
    pleaseUploadAttachmentFirst: '请先上传附件',
    pleaseSelectVisitRecordFirst: '请先选择参访记录',
    pleaseCompleteReimburseForm: '请先完善报销申请表单',
    noWithdrawData: '没有可提现数据',
    pleaseEnterPayeeName: '请输入收款人姓名',
    pleaseEnterBankName: '请输入开户银行',
    pleaseEnterPayeeAccount: '请输入收款账号',
    pleaseEnterContactPhone: '请输入联系电话',
    noInvoiceUploadTip: '您未上传任务发票信息，不可提交总部财务审核，请上传发票后再提交！',
    operationFailRetry: '操作失败，请重试',
    getDataFail: '获取失败',
    deleteFail: '删除失败',
    operationSuccessExclamation: '操作成功！',
    operationFailExclamation: '操作失败！',
    pleaseEnterInvoiceType: '请输入发票类型',
    operationNotAllowed: '不允许操作',
    invoiceSuccess: '开票成功',
    invoiceFail: '开票失败',
    noValidUploadData: '没有一条符合上传的数据',
    pleaseEnterPurchaseNo: '请输入采购单号',
    onlyXlsxXlsFormat: '仅支持 .xlsx 和 .xls 格式的文件',
    pleaseSelectFileFirst: '请先选择文件',
    importSuccess: '导入成功',
    importFail: '导入失败',
    onlyImageFormat: '只能上传JPG、JPEG、GIF、PNG、BMP格式的图片',
    exceed5MLimit: '超过5M限制，不允许上传',
    maxOneImage: '上传的图片不能超过1张',
    applyOrderNo: '申请单号',
    applyWithdrawAmount: '申请提现金额',
    pleaseEnterWithdrawAmount: '请输入提现金额',
    bankInfoPlaceholder: '须包括省市、总行及分/支行信息',
    bankExample: '例：中国工商银行江苏省南京市福建路支行',
    contactPhone: '联系电话',
    auditRemark: '审核备注',
    invoiceUpload: '发票上传：',
    maxUpload5Pdf: '最多上传5个pdf文件',
    noInvoiceData: '暂无发票信息',
    invoiceUploadTip: '请优先上传可红冲发票，如果没有可红冲发票，请上传未开票订单的截图，财务会根据提现金额扣减相应的订单开票金额！',
    invoiceInfo: '开票信息：',
    invoiceUnit: '开票单位',
    invoiceItem: '发票项目',
    invoiceAmount: '开票金额',
    invoiceN: '发票{n}：',
    withdrawApplyDetail: '提现申请详情',
    withdrawApplySubmitInvoice: '提现申请提交发票',
    withdrawApplyModify: '提现申请修改',
    agent: '代理商',
    agentId: '代理商ID',
    agentName: '代理商名称',
    applyType: '申请类型',
    applyTypeAll: '全部',
    applyTypeWithdraw: '提现申请',
    applyTypeCashTransfer: '转现金申请',
    applyAmount: '申请金额',
    bankAccount: '银行账号',
    applyTime: '申请时间',
    submitTime: '提交时间',
    applicant: '申请人',
    auditor: '审核人',
    pleaseEnterApplyOrderNo: '请输申请单号',
    submitInvoice: '提交发票',
    confirmCancel: '确认取消吗？',
    cashAccountDetail: '转现金账户详情',
    cashAccountSubmitInvoice: '转现金账户提交发票',
    cashAccountModify: '转现金账户修改',
    pleaseEnterApplyAmount: '请输入申请金额',
    pleaseEnterTransferAmount: '请输入转现金账户金额',
    withdrawAccountInsufficient: '提现账户余额不足！',
    noInvoiceConfirmSubmit: '您未上传任何发票信息，是否确定提交总部财务审核？',
    pleaseEnterContact: '请输入联系方式',
    refundRecordListExport: '退款记录列表导出',
    refundRecordOrderNo: '订单编号',
    refundInfo: '退费信息',
    refundSignMain: '签约主体',
    refundOrgIdName: '组织ID/组织名称',
    refundHandStatus: '交接状态',
    refundStatusLabel: '退费状态',
    refundTotalAmount: '退费总金额',
    refundTotalAmountPlaceholder: '请输入退费总金额',
    deductAmount: '扣款金额',
    deductAmountPlaceholder: '请输入扣款金额',
    convertOption: '转换期权',
    convertOptionPlaceholder: '请输入转换期权',
    exchangeClassFee: '兑换课时费',
    exchangeAmountPlaceholder: '请输入兑换金额',
    actualRefundAmount: '实际退款金额',
    actualRefundAmountPlaceholder: '请输入实际退款金额',
    terminationAgreementEndTime: '终止协议终止时间',
    terminationAgreementEntryTime: '终止协议录入时间',
    refundMethod: '退费方式',
    refundMethodPlaceholder: '请输入退费方式',
    refundReasonLabel: '退费原因',
    refundReasonPlaceholder: '请输入退费原因',
    firstRefundTimeLabel: '第一笔出款时间',
    firstRefundAmountLabel: '第一笔出款金额',
    secondRefundTimeLabel: '第二笔出款时间',
    secondRefundAmountLabel: '第二笔出款金额',
    lastRefundTimeLabel: '最后一笔出款时间',
    lastRefundAmountLabel: '最后一笔出款金额',
    otherLoanTimeLabel: '其他出款时间',
    otherLoanAmountLabel: '其他出款金额',
    otherLoanAmountPlaceholder: '请输入其他出款金额',
    otherLoanRemarkLabel: '其他出款备注',
    otherLoanRemarkPlaceholder: '请输入备注',
    refundCycleLabel: '第几期打款',
    refundCyclePlaceholder: '请输入期数',
    terminationAttachmentLabel: '附件（终止协议）：',
    uploadFileButton: '上传文件',
    refundPaymentInfo: '退费打款信息',
    attachment: '附件',
    addRefundPaymentInfoTitle: '新增退费打款信息',
    refundAmountLabel: '退费金额',
    refundAmountPlaceholder: '请输入退费金额',
    refundAccountLabel: '退款账号',
    refundAccountPlaceholder: '请输入退款账号',
    refundTimeLabel: '出款时间',
    uploadAttachmentButton: '上传附件',
    cancelRefund: '取消退费',
    cancelRefundConfirmPrefix: '是否确定要取消“',
    cancelRefundConfirmSuffix: '”的退费？',
    maxUpload50M: '最大可上传50M的文件',
    uploadSuccessWithName: '{name} 上传成功',
    uploadFailWithName: '{name} 上传失败',
    productModel: '商品型号',
    unitPrice: '单价',
    pleaseFillAmount: '请填写金额',
    pleaseFillPayMethod: '请填写支付方式',
    pleaseSelectPayTime: '请选择付款时间',
    pleaseSelectRechargeTime: '请选择充值时间',
    pleaseSelectFlowStatus: '请选择流水状态',
    paySerial: '支付流水',
    pleaseFillPaySerial: '请填写支付流水',
    pleaseUploadImage: '请上传图片',
    fillError: '填写错误',
    fail: '失败',
    totalLabel: '合计 ：',
    sendEmail: '发送邮箱',
    deviceAmount: '设备金额',
    softwareAmount: '软件金额',
    recalcAmount: '重算项目金额',
    save: '保存',
    pleaseEnterEmail: '请输入发送邮箱',
    invalidEmailFormat: '输入邮箱格式有误!',
    pleaseEnterDeviceAmount: '请输入设备金额',
    formatErrorNumber: '格式错误，请输入数字！',
    amountCannotBeNegative: '金额不能小于0',
    pleaseEnterSoftwareAmount: '请输入软件金额',
    pleaseSelectInvoiceType: '请选择发票类型',
    invoiceHeaderType: '发票抬头类型：',
    company: '公司',
    personal: '个人',
    companyHead: '公司抬头：',
    pleaseFillCompanyHead: '请填写公司抬头',
    dutyParagraph: '税号：',
    pleaseFillDutyParagraph: '请填写税号',
    phone: '电话：',
    pleaseFillPhone: '请填写电话',
    address: '地址：',
    pleaseFillAddress: '请填写地址',
    pleaseFillBank: '请填写开户银行',
    bankAccountColon: '银行账号：',
    pleaseFillBankAccount: '请填写银行账号',
    invoiceTypeColon: '发票类型：',
    pleaseSelectInvoiceTypeColon: '请选择发票类型',
    email: '电子邮箱：',
    pleaseFillEmail: '请填写电子邮箱',
    businessLicense: '营业执照：',
    clickUploadImage: '点击上传图片',
    legalIdFront: '法人身份证正面：',
    legalIdBack: '法人身份证反面：',
    agentNameColon: '姓名：',
    pleaseFillName: '请填写姓名',
    idCard: '身份证号：',
    pleaseFillIdCard: '请填写身份证号',
    idCardFront: '身份证正面：',
    idCardBack: '身份证反面：',
    previewFile: '预览文件',
    deleteFile: '删除文件',
    emailRequired: '邮箱不能为空',
    pleaseEnterValidEmail: '请输入正确的邮箱格式',
    pleaseUploadBusinessLicense: '请上传营业执照',
    pleaseUploadLegalIdFront: '请上传法人身份证正面',
    pleaseUploadLegalIdBack: '请上传法人身份证反面',
    pleaseUploadIdCardFront: '请上传身份证正面',
    pleaseUploadIdCardBack: '请上传身份证反面',
    onlyImageFormatJpg: '只能上传JPG 、JPEG 、GIF、 PNG、 BMP格式的图片~',
    exceed5MLimitUpload: '超过5M限制 不允许上传~',
    applyWithdraw: '申请提现',
    cashAccountTransfer: '转现金账户',
    autoCalcMaxWithdrawTip: '根据所选充值类型，自动计算最高可提现金额',
    saveAutoGenerate: '保存时自动产生，不可修改',
    maxWithdrawableAmount: '最高可提现金额',
    maxApplyAmount: '最高可申请金额',
    contactAutoFromInvoice: '自动从发票抬头获取，可修改',
    close: '关闭',
    nonPaymentInvoiceTip: '非货款开票提醒',
    invoiceSubmitTip: '请开票完成后，去"财务中心->代理商帐户->转现金账户申请"中提交发票',
    gotIt: '我知道了',
    paymentInvoiceTip: '货款开票提醒',
    businessLicenseShort: '营业执照',
    idCardFrontShort: '身份证正面',
    idCardBackShort: '身份证反面',
    invoiceConfirmTip: '开票信息一旦确认，将不可更改，是否确认',
    cancelConfirm: '取消确认',
    cancelConfirmTip: '是否取消确认',
    rechargeNow: '立即充值',
    note: '注：',
    deductStorageFee: '扣除仓储管理费',
    deductStorageFeeConfirm: '是否从经销商的提货券账户扣除仓库管理费？',
    deductStorageFeeCannotTip: '已扣费或未确认的到期记录，不可进行扣费，请重新选择。',
    reimburseApply: '报销申请',
    expressNo: '快递单号',
    view: '查看',
    visitRecord: '参访记录',
    confirmCancelReimburse: '确定取消该条报销吗？',
    viewAttachment: '查看附件',
    confirmDeleteRecord: '此操作将永久删除该记录, 是否继续?',
    visitCustomerName: '参访客户姓名',
    visitCustomerPhone: '参访客户手机',
    visitCampusId: '参访经销商ID',
    visitCampusName: '参访经销商名称',
    storeId: '门店ID',
    visitStoreAddress: '参访门店地址',
    deliveryDate: '发货日期',
    pleaseSelectSubscriptionAgent: '请选择订阅卡代理商',
    purchaseQty: '采购数量',
    invoiceConfirm: '发票确认',
    regionAgentName: '发货区代名称',
    regionAgentId: '发货区代ID',
    returnAmount: '货款金额',
    currentBalance: '当前余额',
    confirmAmountLabel: '确认金额',
    confirmTime: '确认时间',
    signTime: '签到时间',
    auditTime: '审核时间',
    to: '至',
    reimburseNo: '报销单号',
    pleaseEnterNo: '请输入单号',
    createBy: '创建人',
    creator: '创建人',
    reimburseTotalAmount: '报销总金额',
    expressCompany: '快递公司',
    expressPhone: '快递手机号',
    invoiceMailAddress: '发票邮寄地址',
    recipientInfo: '收件人信息',
    reimburseInvoiceUpload: '报销发票上传',
    pleaseSelectVisitRecord: '请选择参访记录',
    selectVisitRecord: '选择参访记录',
    confirmDelete: '确认删除吗？',
    reimburseTip: '请将报销的纸质发票邮寄到上述地址，并填写准确的快递单号，以便总部人员及时处理！',
    uploadPdfOrImage: '请上传pdf文件或者图片',
    invoiceAddressExample: '上海市闵行区莲花路1080弄 E栋5楼',
    recipientInfoExample: '沈梦宇 18918671328',
    statementConfirm: '对账单确认',
    confirmResult: '确认结果：',
    noWithdraw: '不提现',
    payeeNameConsistent: '须与本代理商主体名称一致',
    bankExampleShort: '例:中国工商银行江苏省南京市福建路分行',
    confirmInvoiceAmountTotal: '确认发票余额合计：',
    unconfirmInvoiceAmountTotal: '未确认发票余额合计：',
    statementConfirmTip1: '1、提现，一旦确认，余额即刻从现金账户中扣除，结果将无法更改；',
    statementConfirmTip2: '2、提现确认后，将由财务统一线下打款给各区域代理商；',
    statementConfirmTip3: '3、选择提现，请务必准确填写收款账号信息；',
    statementConfirmTip4: '4、不提现，一旦确认，余额将继续留在原账户用于订单支付，结果将无法更改；',
    statementConfirmTip5: '5、仅针对已确认收到发票的订单返还金额才可申请提现；',
    audit: '审核',
    return: '返还',
    pleaseEnterReturnNo: '请输入使用返还单号',
    returnOrder: '返还订单',
    subscriptionCashReturnAmount: '订阅卡现金返还金额',
    payVoucher: '支付凭证',
    auditPass: '审核通过',
    auditReject: '审核驳回',
    auditResult: '审核结果',
    invoiceAmountColon: '发票金额：',
    cashAccountReturnInfo: '现金账户返还信息',
    accountName: '账户名',
    accountNo: '账户编号',
    returnRecord: '返还单处理记录',
    subscriptionVerifyDetail: '订阅卡核销明细',
    processTime: '处理时间',
    processBy: '处理人',
    processResult: '处理结果',
    verifySerialNo: '核销流水号',
    subscriptionCardNo: '订阅卡卡号',
    subscriptionCardType: '订阅卡类型',
    subscriptionAgentId: '订阅卡代理商ID',
    subscriptionAgentName: '订阅卡代理商名称',
    cashPayAmount: '现金支付金额',
    voucherPayAmount: '裂变支付金额',
    agentCashReturnAmount: '代理商现金返还金额',
    agentVoucherReturnAmount: '代理商裂变返还金额',
    refundAmount: '退款金额',
    refundAccount: '退款账户',
    refundTime: '退款时间',
    refundType: '退款类型',
    refundBy: '退款人',
    totalFlowCount: '共{n}笔流水，支付金额合计{symbol}{m}{unitSuffix}',
    payAmountTotal: '支付金额合计{symbol}{m}{unitSuffix}',
    applyStatusLabel: '状态',
    pleaseSelectStatus: '请选择状态',
    cashReturnAmount: '现金返还金额',
    fissionReturnAmount: '裂变返还金额',
    lastEditTime: '最新编辑时间',
    lastProcessor: '最新处理人',
    expenditureMethod: '支出方式',
    payTypeLabel: '支付类型',
    paymentFlowDataType: {
      purchase_order: '采购支付',
      private_order: '区域支付',
      withdrawal_order: '提现支付',
      store_order: '仓储管理费支付',
      settlement_order: '结算单支付',
      gold_order: '金币支付',
    },
    accountChangeType: '账户变动类型',
    accountRecharge: '账户充值',
    accountExpense: '账户支出',
    accountTransfer: '账户转移',
    unread: '未读',
    read: '已读',
    sendTime: '发送时间',
    noticeContent: '通知内容',
    accountChangeNotice: '账户变动通知',
    readAction: '阅读',
    readSuccess: '已阅读',
    settlementNo: '结算单号',
    settlementType: '结算类型',
    settlementStatus: '结算状态',
    pleaseSelectSettlementType: '请选择结算类型',
    pleaseSelectSettlementStatus: '请选择结算状态',
    expenditureTransferMethod: '支出/转移方式',
    pleaseSelectItem: '请选择项目',
    pleaseSelectTransferInAgent: '请选择转入代理商',
    transferInAccountType: '转入账户类型',
    pleaseSelectTransferInAccountType: '请选择转入账户类型',
    transferInItem: '转入项目',
    lastPayTimeLabel: '最后支付时间',
    pleaseEnterCreator: '请输入创建人',
    accountChangeNotification: '账户变动通知',
    pleaseSelectChangeType: '请选择类型',
    pleaseSelectRefundType: '请选择退款类型',
    pleaseSelectRefundAccount: '请选择退款账户',
    pleaseEnterOrderNoShort: '请输入订单编号',
    batchConfirm: '批量确认',
    batchBindOrder: '批量绑定订单',
    confirmRechargeToWithdraw: '系统将返佣金额充值到代理商提现账户，是否确认重置？',
    serviceProviderStatus: '服务商状态',
    rechargeStatus: '充值状态',
    confirmed: '确认',
    commissionMonth: '返佣月份',
    commissionRechargeType: '返佣充值类型',
    returnFirstOrderRebate: '首笔订货款-返还',
    subscriptionFeeRebate: '订阅费返佣',
    commodityAddedServiceFee: '商品增值服务费',
    amount: '金额',
    generateTime: '生成时间',
    confirmBy: '确认人',
    pleaseSelectMonth: '请选择月份',
    totalFlowRechargeAmount: '共{n}笔流水，充值金额合计{m}元',
    flowStatus: '流水状态',
    confirmRemark: '确认备注',
    financeConfirm: '财务确认',
    bindOrder: '绑定订单',
    paymentConfirm: '收款确认',
    rechargeAmountColon: '充值金额：',
    rechargeTimeColon: '充值时间：',
    rechargeSerialColon: '充值流水：',
    flowStatusColon: '流水状态：',
    rechargeVoucher: '充值凭证',
    rechargeVoucherColon: '充值凭证：',
    returnBack: '退回',
    invalid: '作废',
    reissue: '重开',
    confirmInvalidInvoice: '确认作废本张发票吗，一旦作废不可恢复！',
    isInvalid: '是否作废',
    yes: '是',
    no: '否',
    pleaseSelectInvalid: '请选择是否作废',
    invoiceNo: '发票编号',
    controlInvoicesOrderNo: '订单编号',
    pleaseEnterInvoiceNo: '请输入发票编号',
    imageLoadFail: '图片资源失效',
    invalidSuccess: '作废成功',
    invalidFail: '作废失败',
    annexPreview: '附件预览',
    batchBindSuccess: '批量绑定成功',
    batchBindFail: '批量绑定失败',
    remarkColon: '备注：',
    confirmRemarkColon: '确认备注：',
    indexNo: '序号',
    projectName: '项目名称',
    specModel: '规格型号',
    itemCount: '数量',
    taxAmount: '税额',
    invoiceDate: '开票时间',
    rechargeIdLabel: '充值ID',
    pleaseEnterRechargeId: '请输入充值ID',
    payMethodLabel: '充值方式',
    itemType: '项目',
    transferAmountLabel: '转出金额',
    pendingConfirm: '待确认',
    pleaseSelectConfirmBy: '请选择确认人',
    pleaseEnterPhoneShort: '请输入电话',
    nameLabel: '名称',
    searchByNamePlaceholder: '根据个人姓名、公司抬头进行模糊搜索',
    headType: '抬头类型',
    pleaseSelectHeadType: '请选择抬头类型',
    companyHeadOrName: '公司抬头/个人姓名',
    dutyParagraphShort: '税号',
    idCardShort: '身份证号',
    invoiceAssortName: '发票类型',
    addressShort: '地址',
    bankShort: '开户银行',
    bankAccountShort: '银行账户',
    cycleExpiryTime: '周期到期时间',
    exemptionExpiryNo: '豁免到期编号',
    pleaseEnterNoShort: '请输入编号',
    agentTypeShort: '代理商类型',
    pleaseSelectType: '请选择类型',
    currentCycle: '当前周期',
    initialBalance: '期初余额',
    currentPeriodReceiveAmount: '当前期收到提货券金额',
    currentPeriodConsumeAmount: '当期消耗提货券金额',
    exemptionNonOrderAmount: '豁免到期未下单提货券金额',
    exemptionNonOrderNum: '豁免到期未下单设备数量',
    estimatedCost: '预计产生费用',
    actualCost: '实际扣除费用',
    deductTime: '扣费时间',
    deductBy: '扣费人',
    obtainRecord: '获取记录',
    transferRecord: '转账记录',
    myIssuedVoucher: '我发放的提货券',
    myVerifiedVoucher: '我核销的提货券',
    myReceivedVoucher: '我收到的提货券',
    myConsumedVoucher: '我消费的提货券',
    equityDesc: '权益描述',
    equityDescTitle: '权益描述 - {name}',
    rightType: '权益类型',
    pleaseSelectRightType: '请选择权益类型',
    rightName: '权益名称',
    pleaseEnterRightName: '请输入权益名称',
    rightCode: '权益编码',
    pleaseEnterRightCode: '请输入权益编码',
    grantTime: '发放时间',
    obtainTime: '获得时间',
    verifyTime: '核销时间',
    recordNo: '流水号',
    pleaseEnterRecordNo: '请输入流水号',
    purchaseNoCol: '采购单号',
    purchaseOrderNo: '采购订单',
    pleaseEnterPurchaseOrder: '请输入采购订单',
    consumeCampusId: '归属代理商ID',
    consumeCampusName: '归属代理商名称',
    consumeVoucherAmount: '消费提货券金额',
    grantCampusId: '发放代理商ID',
    grantCampusName: '发放代理商名称',
    relatedCampusId: '关联代理商ID',
    relatedCampusName: '关联代理商名称',
    consumeBy: '消费人',
    grantRemark: '发放备注',
    consumeRemark: '消费备注',
    grantBy: '发放人',
    receiveCampusId: '归属代理商ID',
    receiveCampusName: '归属代理商名称',
    expirationTime: '过期时间',
    verifyCampusId: '核销代理商ID',
    verifyCampusName: '核销代理商名称',
    verifyAmount: '核销金额',
    verifyOrder: '核销订单',
    verifyBy: '核销人',
    rightForm: '权益形式',
    pleaseSelectRightForm: '请选择权益形式',
    validDeadline: '有效截止时间',
    distributeBy: '发放人',
    validityPeriod: '有效期',
    belongDealer: '归属经销商',
    consNo: '核销单号',
    consTime: '核销时间',
    consType: '核销方式',
    consRemark: '备注',
    rightLevel: '权益等级',
    rightAmount: '权益金额',
    applicableModel: '适用商品型号',
    rightDiscount: '权益折扣',
    marketingActivity: '参与的营销活动',
    activityPrice: '活动价',
    rightQuantity: '权益数量',
    exclusiveAttr: '专有属性',
    withdrawRecord: '提现记录',
    cashTransferRecord: '转现金账户记录',
    newDoubleOrder: '新建双重订单',
    agentNotActivatedTip: '该代理商账号尚未激活，是否继续下双重订单?',
    withdrawableAmountColon: '可提现金额：',
    goldAccountBalance: '金帐户余额',
    transferNo: '流水号',
    transferNum: '操作数量',
    goldCoinTransferTime: '转账时间',
    transferOutAccount: '转出账户',
    transferInAccount: '转入账户',
    pleaseSelectAccount: '请选择账户',
    pleaseSelectReceiveAccount: '请选择获取账户',
    consumeNo: '流水号',
    consumeNum: '消费数量',
    consumeTime: '消费时间',
    consumeAccount: '消费账户',
    studentName: '学员姓名',
    studentAccount: '学员账号',
    pleaseEnterStudentName: '请输入学员姓名',
    obtainNo: '流水号',
    obtainNum: '获取数量',
    obtainMethod: '获取方式',
    pleaseSelectObtainMethod: '请选择获取方式',
    obtainTimeLabel: '获取时间',
    obtainUser: '获取用户',
    cashAccountBalance: '现金帐户余额',
    deliveryVoucherBalance: '提货券余额',
    subAgentLabel: '下级代理商',
    createFail: '新建失败！',
    nonCompanyWithdrawTip: '您当前代理商主体非公司性质，请去"财务中心->发票->发票抬头维护"中，填写公司类型的申请，该申请由松鼠行政审核通过后再来申请提现。',
    applySuccess: '申请成功！',
    /** 提现申请成功后（非货款类与美版等特殊分支提示文案） */
    saveSuccessAwaitFinanceReview: '保存成功，等待财务审核和打款！',
    applyFail: '申请失败！',
    loanTransferAutoConfirmTip: '因为提现账户的货款转现金账户，无需开票，自动审核确认，并已将该申请金额转移至现金账户！',
    transferSuccessTip: '提交成功，并已将该申请金额转移至现金账户！',
    exemptionExpiringAmount: '即将过豁免期提货券金额',
    estimatedStorageFee: '预计收取仓库管理费',
    agentGoldAccount: '代理商金币账户',
    staffGoldAccount: '员工金币账户',
    goToPurchase: '前往购买',
    jumpToMiniProgram: '跳转小程序',
    snCodeUpdate: 'SN码更新',
    oldSNCode: '旧SN码：',
    newSNCode: '新SN码：',
    pleaseEnterOldSNCode: '请输入旧SN码',
    pleaseEnterNewSNCode: '请输入新SN码',
    addServiceCenter: '新增服务中心',
    serviceAddress: '服务中心地址：',
    pleaseEnterAgentId: '请输入代理商ID',
    pleaseEnterServiceAddress: '请输入服务中心地址',
    agentOrderStatusUpdate: '代理商订单状态更新',
    purchaseNo: '采购单号：',
    purchaseType: '采购类型：',
    orderStatus: '订单状态：',
    dispatchType: '发货方式：',
    pleaseEnterPurchaseNoShort: '请输入购单号',
    pleaseSelectPurchaseType: '请选择采购类型',
    pleaseSelectOrderStatus: '请选择订单状态',
    pleaseSelectDispatchType: '请选择发货方式',
    pleaseEnterRegionAgentId: '请输入发货区代ID',
    agentWarehouse: '代理商京东仓：',
    pleaseSelectAgentWarehouse: '请选择代理商收获仓库',
    applicationType: '申请类型',
    transferIn: '转入',
    transferOut: '转出',
    transferType: '转移',
    batchTransferIn: '批量转入',
    transferOutAgentLabel: '转出代理商',
    agentLabel: '代理商',
    payAmountLabel: '支付金额',
    transferOutAmount: '转出金额',
    selectFileAndImport: '选择需要导入的文件，并开始导入',
    dragOrClick: '将文件拖到此处，或',
    clickUpload: '点击上传',
    attachments: '附件',
    pleaseEnterRemark200: '请输入备注，200字以内',
    balance: '余额',
    time: '时间',
    status: '状态',
    yuan: '元',
    errorOccurred: '发生错误',
    statusPendingSubmit: '待提交',
    statusPendingAudit: '待审核',
    statusReturned: '已退回',
    statusCancelled: '已取消',
    statusPendingPayment: '待打款',
    statusCompleted: '已完成',
    pleaseSelectInitialAccount: '请选择初始账户',
    pleaseEnterInitialAmount: '请输入初始金额',
    pleaseSelectPayMethod: '请选择付款方式',
    pleaseEnterPaySerialNo: '请输入付款流水',
    pleaseSelect: '请选择状态',
    jiedanhao: '结算单号',
    mu: '项目',
    chu: '支出方式',
    caozuo: '操作人',
    pleaseEnter: '请输入使用返还单号',
    hao: '身份证号',
    valuation: '估值',
    order: '采购订单',
    student: '学员',
    chuzhanghu: '转出账户',
    ruzhanghu: '转入账户',
    dianhua: '电话',
    dian: '电子邮箱',
    individual: '个人',
    pending: '待确认',
    already: '已确认',
    not: '未确认',
    danhao: '返还单号',
    xinli: '最新处理人',
    textfhuc: '姓名',
    text1k65: '市区',
    text6n7l: '王小虎',
    textqeco: '上海',
    textiq60: '上海市普陀区金沙江路',
    textt7uv: '省份',
    text7633: '邮编',
    texteb5j: '普陀区',
    text5owf: '当前可用样机指标',
    textmv1l: '采购设备获得样机指标',
    textv66y: '活动获得样机指标',
    textg5ii: '已使用样机指标',
    withdrawStatusReturned: '已退回',
    withdrawStatusCompleted: '已完成',
    date: '日期',
    invoiceType: '发票类型',
    quantity: '数量',
    taxRatio: '税率',
    type: '返佣充值类型',
    xiaozhanghu: '消费账户',
    name: '代理商名称',
    zhanghu: '银行账户',
    qu: '获取方式',
    kaihu: '开户银行',
    month: '返佣月份',
    queren: '确认人',
    qing: '申请人',
    textzuxc: '姓名',
    textkxzs: '市区',
    text2gks: '商品名称',
    equityDescLabel: '权益说明：',
    equityUsageLabel: '权益使用方法：',
    // 月度账单 - 列表页
    monthlyBill: '月度账单',
    monthlyBillYear: '年份',
    pleaseSelectYear: '请选择年份',
    monthlyBillMonth: '账单月份',
    monthlyBillNo: '账单编号',
    fixedRoyaltyFee: '固定权利金',
    registrationFee: '注册费',
    supervisionFee: '督学费',
    marketingFeeLabel: '行销费',
    subtotal: '小计',
    monthlyBillTotal: '账单总额',
    monthlyBillStatus: '状态',
    paymentDeadline: '支付截止日',
    monthlyBillViewDetail: '查看详情',
    monthlyBillPay: '支付',
    monthlyBillBillOf: '{month}月账单',
    cumulativePayment: '累计缴费',
    annualTotal: '{year}年度',
    totalNPeriods: '{year}年共{n}期',
    generatedOn: '已于 {date} 自动生成',
    billHistoryTitle: '账单历史',

    // 设备转期权
    equipmentToOption: {
      pageTitle: '库存设备转期权',
      modelLabel: '机型',
      allModels: '全部机型',
      warehouseLabel: '所在仓库',
      allWarehouses: '全部仓库',
      applyStatusLabel: '申请状态',
      allStatus: '全部',
      pleaseSelect: '请选择',
      searchButton: '查询',
      resetButton: '重置',
      totalDevices: '共 {count} 台设备',
      exportButton: '导出',
      submitApplyButton: '转期权申请',
      confirmDialogTitle: '确认提交转期权申请',
      confirmDialogDesc: '请确认以下申请信息，提交后设备将进入锁定状态，等待总部审核。',
      deviceCount: '申请设备数量',
      totalAmount: '合计期权金额',
      applicant: '申请人',
      warningTip: '提交后将生成转期权申请单，审核通过后设备将转为期权状态，无法再进行库存出库操作',
      cancelButton: '取消',
      confirmButton: '确认提交',
      pleaseSelectDevices: '请先勾选需要提交的设备',
      appliedStatusWarning: '已申请状态的设备不可提交转期权申请',
      storeCloudSeparateWarning: '云仓设备与线下门店设备请分别提交申请！',
      submitSuccess: '提交成功',
      submitFailed: '提交失败',
      queryFailed: '查询失败',
      offlineStore: '线下门店',
      yuan: '¥',
      unit: '台',
      applicantFormat: '{name}（ID {campusId}）',
      statusUnapplied: '未申请',
      statusAuditing: '审核中',
      statusAudited: '已审核',
      statusCompleted: '已完成',
      statusRejected: '已驳回',
      statusCanceled: '已取消',
      columnSnCode: 'SN码',
      columnWarehouse: '所在仓库',
      columnModel: '机型',
      columnInboundTime: '入库时间',
      columnLevelAPrice: 'A级进货价',
      columnDiscount: '折扣',
      columnDiscountedAmount: '折扣后金额(¥)',
      columnApplyStatus: '申请状态'
    },
    equipmentToOptionApply: {
      pageTitle: '库存设备转期权申请',
      applyNo: '申请单号',
      pleaseEnterApplyNo: '请输入申请单号',
      applyStatus: '申请状态',
      pleaseSelectApplyStatus: '请选择申请状态',
      applyTime: '申请时间',
      to: '至',
      applyDeviceNum: '申请设备数',
      totalOptionAmount: '合计期权金额(￥)',
      auditTime: '审核时间',
      rejectReason: '驳回原因',
      operation: '操作',
      cancel: '取消',
      viewDetail: '查看明细',
      detailTitle: '申请设备明细',
      exportDetail: '导出明细',
      cancelDialogTitle: '确认取消',
      cancelDialogContent: '当前转期权申请一旦取消，所有设备将释放可激活，是否确认？',
      cancelSuccess: '取消成功',
      cancelFailed: '取消失败',
      queryFailed: '查询失败',
      detailQueryFailed: '明细查询失败',
      total: '合计',
      detailTotalAmount: '合计金额',
      statusAuditing: '审核中',
      statusAudited: '已审核',
      statusCompleted: '已完成',
      statusRejected: '已驳回',
      statusCanceled: '已取消',
      columnIndex: '#',
      columnSnCode: 'SN码',
      columnModel: '机型',
      columnWarehouse: '所在仓库',
      columnLevelAPrice: 'A级进货价(￥)',
      columnDiscount: '折扣',
      columnDiscountedAmount: '折扣后金额(￥)'
    },
    accountBalanceToOptionApply: {
      pageTitle: '账户余额转期权',
      applyNo: '申请单号',
      pleaseEnterApplyNo: '请输入申请单号',
      applyStatus: '申请状态',
      pleaseSelectApplyStatus: '请选择申请状态',
      applyTime: '申请时间',
      goldAccount: '金账户',
      cashAccount: '现金账户',
      voucherAccount: '裂变账户',
      withdrawalAccount: '提现账户',
      totalAmount: '申请总金额',
      auditTime: '审核时间',
      rejectReason: '驳回原因',
      operation: '操作',
      view: '查看',
      modify: '修改',
      cancel: '取消',
      applyButton: '余额转期权申请',
      createTitle: '余额转期权申请',
      modifyTitle: '修改余额转期权申请',
      viewTitle: '查看余额转期权申请',
      account: '账户',
      accountBalance: '当前可用余额',
      applyAmount: '本次申请转出金额',
      applyTotalAmount: '申请总金额',
      applyDialogDesc: '请选择需要转出的账户及金额（各账户金额不超过当前可用余额），提交后等待总部审核。',
      auditTip: '审核通过后，申请金额将正式从各账户扣除，并自动充值至期权账户；驳回则无实际扣款。',
      close: '取消',
      confirm: '确认提交',
      statusAuditing: '审核中',
      statusCompleted: '已完成',
      statusCanceled: '已取消',
      statusRejected: '已驳回',
      queryFailed: '查询失败',
      balanceQueryFailed: '账户余额查询失败',
      totalAmountRequired: '申请总金额必须大于0',
      amountOverAvailable: '申请转出金额必须小于等于当前可用余额',
      submitSuccess: '提交成功',
      submitFailed: '提交失败',
      cancelSuccess: '取消成功',
      cancelFailed: '取消失败',
      cancelDialogContent: '确认取消该余额转期权申请吗？'
    },
    // 月度账单 - 状态
    billStatusPending: '待支付',
    billStatusPaid: '已支付',
    billStatusReviewing: '待审核',
    billStatusOverdue: '逾期未支付',
    billStatusRejected: '已驳回',
    // 月度账单 - 详情页
    monthlyBillDetail: '月度账单详情',
    stepBillGenerated: '账单生成',
    stepUploadVoucher: '上传凭证',
    stepHqAudit: '总部审核',
    stepPaid: '已支付',
    feeBreakdown: '费用明细',
    feeCategory: '费用类别',
    feeItem: '费用项目',
    calcBasis: '计算依据',
    feeAmount: '金额',
    royaltyFeeGroupTitle: '权利金',
    marketingFeeGroupTitle: '行销费',
    royaltyFeeSubtotalLabel: '权利金小计',
    feeLineMonthlyFixed: '① 每月固定费用',
    feeLineSupervision: '② 督学费{rateText}',
    feeLineNewRegFee: '③ 新生注册费',
    marketingFeeItemLine: '（督学+注册）×{rate}%',
    marketingFeeCalcLine: '（{s}+{r}）×{p}%',
    studentsCountUnit: '名学员',
    newStudentsCountUnit: '名新学员',
    feeTotal: '合计',
    monthlyFixedCollection: '月固定收取',
    supervisionStudentDetail: '督学学员明细',
    registrationStudentDetail: '注册学员明细',
    supervisionStart: '督学开始',
    supervisionEnd: '督学结束',
    supervisionResult: '督学结果',
    supervisionStatus: '督学状态',
    registrationTime: '注册时间',
    deviceSN: '设备SN',
    accountStatusLabel: '账号状态',
    totalStudents: '共 {n} 名学员',
    studentIdColumn: '学员 ID',
    voucherListItem: '凭证 {n}',
    // 月度账单 - 督学费标准说明（countryId + standardMatchType）
    supervisionFeeStandardPrefix: '督学费标准：',
    supervisionStandardHit: '命中',
    supervisionStandardDealerExclusive: '经销商ID专属标准',
    supervisionStandardTierProvinceCN: '省标准',
    supervisionStandardTierCityCN: '市标准',
    supervisionStandardTierDistrictCN: '区标准',
    supervisionStandardTierStateUS: '州标准',
    supervisionStandardTierCountyUS: '县标准',
    supervisionStandardTierCityUS: '市标准',
    supervisionStandardPerStudentMonth: '/学员/月',
    supervisionStandardCalcPart: '{n}名有效督学学员 × {unit} × {rate}% = {total}',
    // 月度账单 - 支付
    paymentInfo: '支付信息',
    submitPayment: '提交支付',
    uploadPaymentProof: '上传支付凭证',
    uploadTip1to5: '请上传1~5个凭证文件（JPG/PNG/PDF），可一次多选',
    submitVoucherWaitAudit: '提交凭证，等待审核',
    uploadedVouchers: '已上传凭证',
    rejectReason: '驳回原因',
    paymentSubmitSuccess: '支付凭证提交成功，请耐心等待审核',
    pleaseUploadAtLeastOne: '请至少上传一张支付截图',
    maxUpload5Images: '最多上传5张图片',
    onlyJpgPngAllowed: '只允许上传JPG、JPEG、PNG、PDF格式',
    imageSizeExceed5M: '文件不能超过20MB',
    voucherVerified: '凭证已审核，无需操作',
    billAmount: '账单金额',
    payTimeLabel: '支付时间',
    auditTimeLabel: '审核时间',
    billRemarkLabel: '备注（选填）',
    billRemarkPlaceholder: '请输入备注',
    pendingVoucherTip: '您有1笔账单处于【待支付】状态，请在 {date} 前完成银行电汇并上传凭证，逾期将影响督学服务使用。',
    paymentInstructionTitle: '支付说明',
    paymentInstructionLine1: '请在 {date} 前完成银行电汇（{amount}）',
    paymentInstructionLine2: '转账完成后，在下方上传支付凭证',
    paymentInstructionLine3: '总部审核后将更新账单状态',
    paymentInstructionLine4: '逾期未支付将影响督学服务使用',
  },
  financeCenter: {
    valuation: "估值",
    auto_1_6b6ece34: "付款1",
    auto_1_ebc377a4: "提交失败1",
    auto_2_745edc9e: "修改2",
    auto_2_d4954d6e: "核销代理商2",
    auto_3_9187db9b: "核销代理商名称3",
    auto_3_ea766e30: "发票确认3",
    auto_4_7027499f: "流水号4",
    auto_4_e82041b8: "更多4",
    auto_5_6f265697: "取消5",
    auto_5_cf628124: "核销金额5",
    auto_6_3682d1dc: "提交6",
    auto_6_dca8bab5: "发放代理商6",
    auto_7_6f63d67e: "发放代理商名称7",
    auto_7_c4ce0715: "变更地址7",
    auto_8_92d398e1: "收货确认8",
    auto_8_fb1e1ec8: "核销订单8",
    auto_9_4334790a: "关联代理商9",
    auto_9_729212dd: "操作9",
    auto_10_0d0eb47b: "关联代理商名称10",
    auto_10_a9f42805: "付款10",
    auto_11_19f35b07: "修改11",
    auto_11_5d8b94fd: "核销时间11",
    auto_12_7a1e0aea: "核销人12",
    auto_12_9a934775: "发票确认12",
    auto_13_797c0418: "备注13",
    auto_13_df7b22b8: "更多13",
    auto_14_1162996f: "操作14",
    auto_14_88429bf5: "归属代理商14",
    auto_15_884eec7f: "归属代理商名称15",
    auto_15_d6f54305: "付款15",
    auto_16_28b64976: "流水号16",
    auto_16_fb8dd9be: "修改16",
    auto_17_aad90013: "提货券金额17",
    auto_17_c660f5e5: "发票确认17",
    auto_18_469e30df: "发放代理商18",
    auto_18_67962858: "更多18",
    auto_19_1a2b2e88: "操作19",
    auto_19_3b689608: "发放代理商名称19",
    auto_20_16677134: "付款20",
    auto_20_c8ded2b2: "采购订单20",
    auto_21_68c0645e: "获得时间21",
    auto_21_c37f7ef2: "修改21",
    auto_22_78fb43d0: "过期时间22",
    auto_22_b82fc983: "发票确认22",
    auto_23_4434e40c: "更多23",
    auto_23_4cc548ab: "备注23",
    auto_24_1f4283f9: "归属代理商24",
    auto_24_f4c2d691: "操作24",
    auto_25_0e997a9f: "取消25",
    auto_25_5194ce27: "归属代理商名称25",
    auto_26_c44a0dff: "thisonSureOrderrecord财务确认26",
    auto_26_f87a9ffd: "流水号26",
    auto_27_b1784121: "thisBindOrderrecordrechargeIdt27",
    auto_27_b3b45e9e: "消费提货券金额27",
    auto_28_41f30956: "发放代理商28",
    auto_29_8255c8cb: "发放代理商名称29",
    auto_30_8cbda33e: "采购订单30",
    auto_31_4c4fdf72: "关联代理商31",
    auto_32_d8363811: "关联代理商名称32",
    auto_33_8c1fbd78: "发放时间33",
    auto_34_37f1b74c: "消费人34",
    auto_34_d0862854: "支付34",
    auto_35_155cd631: "发放备注35",
    auto_35_ce7a09eb: "详情35",
    auto_36_a15a703b: "消费备注36",
    auto_36_e8c4a85c: "存货现金价值36",
    auto_37_2057c69a: "流水号37",
    auto_37_55a03750: "请优先提交松鼠开具的发票红冲如无可红冲发票则将现有未开票采购37",
    auto_38_bb8b4786: "消费数量38",
    auto_39_9e95e46b: "消费时间39",
    auto_39_e3ee3b18: "关于样机指标的规则及解读39",
    auto_40_a8a43348: "测试物流40",
    auto_40_bafe5d5f: "消费账户40",
    auto_41_65ec2f30: "学员姓名41",
    auto_42_4711b9cd: "学员账号42",
    auto_43_fd6f12d4: "操作人43",
    directFinReportMonth: "所属年月",
    directFinReportCampusId: "联营店ID",
    directFinReportCampusName: "联营店名称",
    directFinReportType: "报表类型",
    directFinReportStatus: "状态",
    directFinReportAuditStatus: "审核状态",
    directFinReportAuditName: "审核人",
    directFinReportAuditTime: "审核时间",
    directFinReportAuditRemark: "审核意见",
    directFinReportUploadName: "上传人",
    directFinReportUploadTime: "上传时间",
    directFinReportOriginalFile: "文件名称",
    directFinReportFileSize: "文件大小",
    directFinReportRemark: "备注",
    directFinReportDownloadTemplate: "下载报表模板",
    directFinReportTemplateDialogTitle: "下载报表模板",
    directFinReportTemplateVersion: "模板版本",
    directFinReportTemplateFile: "模板文件",
    directFinReportDownloadAllTemplate: "打包下载全部模板",
    directFinReportUpload: "上传",
    directFinReportReupload: "重新上传",
    directFinReportFile: "报表文件",
    directFinReportUploadTip: "将Excel文件拖到此处，或点击上传",
    directFinReportExcelOnly: "仅支持xls/xlsx格式",
    directFinReportOnlyOneFile: "只能上传一个报表文件",
    directFinReportConfirmUpload: "确认上传",
    directFinReportUploadSuccess: "上传成功，等待审核",
    directFinReportValidationFailed: "报表校验失败，请查看错误明细",
    directFinReportDetailTitle: "财务报表详情",
    directFinReportBaseInfo: "基础信息",
    directFinReportValidationResult: "校验结果",
    directFinReportData: "报表数据",
    directFinReportDownloadReport: "下载报表",
    directFinReportOperateLog: "操作日志",
    directFinReportOperateType: "操作类型",
    directFinReportOperateContent: "操作内容",
    directFinReportOperateName: "操作人",
    directFinReportOperateTime: "操作时间",
    directFinReportCellRef: "单元格",
    directFinReportFieldName: "字段",
    directFinReportErrorMessage: "错误说明",
    directStoreReceiptRecord: "直营店收款记录",
    directStoreFlowNo: "流水编号",
    directStoreFlowNoPlaceholder: "请输入流水编号",
    directStoreFlowType: "流水类型",
    directStoreFlowTypePlaceholder: "请选择流水类型",
    directStoreRelatedOrderNo: "关联单号",
    directStoreParentInfo: "家长信息",
    directStoreParentInfoPlaceholder: "请输入家长姓名或手机号",
    directStorePayMethodPlaceholder: "请选择支付方式",
    directStorePayMethodVoucher: "上传凭证",
    directStorePayMethodAggregate: "汇付天下",
    directStoreTransactionTime: "交易时间",
    directStoreRangeTo: "至",
    directStoreReceiptRecordQueryFailed: "直营店收款记录查询失败",
    parentName: "家长姓名",
    parentPhone: "家长手机号",
    amountYuan: "金额（元）",
    receipt: "收款",
    refund: "退款",
    attachment: "附件",
    attachmentPreview: "附件预览",
    noAttachment: "无附件",
    pleaseSelectReportMonth: "请选择所属年月",
    pleaseSelectReportType: "请选择报表类型",
    pleaseSelectReportStatus: "请选择上传状态",
    pleaseSelectReportFile: "请选择报表文件",
    auto_44_39032079: "备注44",
    auto_45_1f40693b: "流水号45",
    auto_46_73372523: "获取数量46",
    auto_47_2c39e54a: "获取方式47",
    auto_48_53c95de1: "获取时间48",
    auto_49_3ebd895a: "获取用户49",
    auto_50_689c2aaf: "操作人50",
    auto_51_1a4fb740: "备注51",
    auto_52_d17a4725: "王小虎52",
    auto_53_28a9915d: "上海53",
    auto_54_d648a147: "普陀区54",
    auto_55_5f6611f6: "上海市普陀区金沙江路55",
    auto_56_3ee2dbc5: "王小虎56",
    auto_57_2451d523: "上海57",
    auto_58_ca225558: "普陀区58",
    auto_59_2d6a5ca7: "上海市普陀区金沙江路59",
    auto_60_898bbf9d: "王小虎60",
    auto_61_97f5b154: "上海61",
    auto_62_56cec1b0: "普陀区62",
    auto_63_f7968f67: "上海市普陀区金沙江路63",
    auto_64_f6b2ed60: "王小虎64",
    auto_65_3de41d78: "上海65",
    auto_66_7c5347c4: "普陀区66",
    auto_67_6b0e8395: "上海市普陀区金沙江路67",
    auto_68_5d335e58: "王小虎68",
    auto_69_f87aa3f3: "上海69",
    auto_70_b2bc7a8e: "普陀区70",
    auto_71_49370797: "上海市普陀区金沙江路71",
    auto_72_ee82bb93: "王小虎72",
    auto_73_957bbacc: "上海73",
    auto_74_8d817d9c: "普陀区74",
    auto_75_a57308c1: "上海市普陀区金沙江路75",
    auto_76_0ef701f3: "王小虎76",
    auto_77_596b3f41: "上海77",
    auto_78_26a95388: "普陀区78",
    auto_79_66e61787: "上海市普陀区金沙江路79",
    auto_80_ef2308ce: "王小虎80",
    auto_81_816335b0: "上海81",
    auto_82_5093ffa7: "普陀区82",
    auto_83_cec78619: "上海市普陀区金沙江路83",
    auto_84_06813cd6: "流水号84",
    auto_85_6d496bf0: "操作数量85",
    auto_86_a845dd6a: "转出时间86",
    auto_87_3cfcfaf4: "转出账户87",
    auto_88_7c8ab76b: "转入账户88",
    auto_89_c114f60c: "操作人89",
    auto_90_18862e79: "备注90",
    auto_91_05b422f9: "代理商91",
    auto_92_28409628: "代理商名称92",
    auto_93_56609012: "金帐户余额93",
    auto_94_e17c9a8e: "现金帐户余额94",
    auto_95_82ecdc81: "提货券余额95",
    auto_97_7a3becf5: "参访门店地址97",
    auto_98_38685431: "签到时间98",
    auto_99_73621379: "参访经销商99",
    auto_100_cb775405: "参访经销商名称100",
    auto_101_1fd8d725: "门店101",
    auto_102_f3526d82: "签到时间102",
    auto_103_0dd369f2: "参访门店地址103",
    auto_104_3f064d4d: "关联代理商104",
    auto_105_73f5d318: "关联代理商名称105",
    auto_106_72c70ecf: "流水号106",
    auto_107_ea502f26: "提货券金额107",
    auto_108_65a5c8a5: "发放代理商108",
    auto_109_12710029: "发放代理商名称109",
    auto_110_67642bea: "采购订单110",
    auto_111_a2375f4e: "发放时间111",
    auto_112_e9efec21: "发放人112",
    auto_113_a2269a72: "备注113",
    auto_114_eb8a1b4d: "(预支指标)",
    auto_116_18891eb0: "代理商116",
    auto_117_e20fb753: "已确认117",
    auto_118_5a6ea357: "剩余未下单金额118",
    auto_119_10de635d: "个人119",
    auto_120_7f351f27: "公司120",
    auto_121_dae829e2: "未读121",
    auto_122_f2d5d8b1: "充值122",
    auto_123_72c869d7: "充值123"
  }
}
